import { render, staticRenderFns } from "./AcButton.vue?vue&type=template&id=e3771274&scoped=true&"
import script from "./AcButton.vue?vue&type=script&lang=js&"
export * from "./AcButton.vue?vue&type=script&lang=js&"
import style0 from "./AcButton.vue?vue&type=style&index=0&id=e3771274&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3771274",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
